<app-take-off-canvas
    #scaleTakeOffCanvas
    [imageUrl]="selectedPlan()?.PlanUrl || selectedPlan()?.fileUrl"
    [drawingMode]="takeoffScaleConfig()?.drawingMode ?? drawingMode.Single"
    [shape]="takeoffScaleConfig()?.shape"
    [unit]="takeoffScaleConfig()?.unit"
    [horizontalScale]="takeoffScaleConfig()?.horizontalScale"
    [verticalScale]="takeoffScaleConfig()?.verticalScale"
    [showLabels]="takeoffScaleConfig()?.showLabels ?? false"
    [mouseScaleStep]="takeoffScaleConfig()?.mouseScaleStep"
    [showZoomSlider]="true"
    [showZoomScaleSlider]="true"
    (drawingFinish)="scaleDrawingFinish($event)"
    (drawingStart)="scaleDrawingStart($event)">
</app-take-off-canvas>
